import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import {useAuth} from '../context/AuthContext';
import { collection, onSnapshot, query, where } from 'firebase/firestore';

const useMainPayment = () => {
	const [payments, setPayments] = useState([]);
	const {usuario} = useAuth();

	useEffect(() => {
		if(usuario){
			const queryDB = query(
				collection(db, 'payments'),				
				where('userId', '==', usuario.uid)
			);

			const unsuscribe = onSnapshot(queryDB, (snapshot) => {
				setPayments(snapshot.docs.map((documento) => {
					return {...documento.data(), id: documento.id}
				}))
			}, (error) => {return error});

			return unsuscribe;
		}
	}, [usuario]);


	return payments;
}
 
export default useMainPayment;